// SummaryCards.tsx — the six headline numbers above the chart.
import type { SimulationResult } from '@etf-cockpit/engine';
import { formatCents, formatDateDe } from '../lib/format.js';

export interface SummaryCardsProps {
  result: SimulationResult;
}

export function SummaryCards({ result }: SummaryCardsProps) {
  const { summary, waterfall, crossover } = result;
  return (
    <div class="summary-grid">
      <Tile label="Endvermögen" value={formatCents(waterfall.netWealthCents)} />
      <Tile label="Eingezahlt" value={formatCents(waterfall.contributedCents)} />
      <Tile label="Kursgewinn" value={formatCents(waterfall.grossGainCents)} />
      <Tile label="Steuern gesamt" value={formatCents(summary.totalKestCents)} />
      <Tile label="KESt bei sofortigem Verkauf" value={formatCents(summary.kestIfSoldNowCents)} />
      <div class="summary-tile">
        <div class="label">Break-even (Gebühren/TER)</div>
        <div class="value" style={{ fontSize: '0.85rem' }}>
          Kumuliert: {formatDateDe(crossover.cumulativeDate)}
        </div>
        <div class="value" style={{ fontSize: '0.85rem' }}>
          Mtl. Rate: {formatDateDe(crossover.monthlyRateDate)}
        </div>
      </div>
      {summary.withdrawal ? (
        <>
          <Tile label="Gesamt entnommen (brutto)" value={formatCents(summary.withdrawal.totalGrossWithdrawnCents)} />
          <Tile label="davon KESt" value={formatCents(summary.withdrawal.totalKestCents)} />
          <div class="summary-tile">
            <div class="label">Entnahmephase</div>
            <div class="value" style={{ fontSize: '0.85rem' }}>
              {summary.withdrawal.depletionDate
                ? `Depot leer am ${formatDateDe(summary.withdrawal.depletionDate)}`
                : 'Reicht über die gesamte Entnahmedauer'}
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
}

function Tile({ label, value, negative }: { label: string; value: string; negative?: boolean }) {
  return (
    <div class="summary-tile">
      <div class="label">{label}</div>
      <div class={`value${negative ? ' negative' : ''}`}>{value}</div>
    </div>
  );
}
